/**
 * Created by Viacheslav Stepanian on 26.08.2026
 */

const WeeklyGoalRow = function (goal, options) {
    options = options || {};

    return Prefab.instantiate(bundles.weekly_goals.jsons.weekly_goal_row_prefab_json, {
        goal,
        disabled: options.disabled
    });
};
